module.exports = __webpack_public_path__ + "img/P.II.e4ccb301.jpg";